import { useTranslation } from "react-i18next";
import HighlightCard from "../../ui/components/HighlightCard";
import analyzedIcon from "../../static/assets/dashboard-waste-analyzed.svg";
import onSiteIcon from "../../static/assets/dashboard-waste-on-site.svg";

const formatVolume = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${Math.round(Number(value))}`;
};

export const DashboardVolumeHighlights = ({ analyzedVolume, onSiteVolume }) => {
  const { t } = useTranslation();

  return (
    <div className="dashboard-volume-row">
      <HighlightCard
        iconSrc={analyzedIcon}
        title={t("dashboard.wasteAnalyzed")}
        hint={t("dashboard.wasteAnalyzedHint")}
        value={
          <>
            {formatVolume(analyzedVolume)} m<sup>3</sup>
          </>
        }
      />
      <HighlightCard
        iconSrc={onSiteIcon}
        title={t("dashboard.wasteOnSite")}
        hint={t("dashboard.wasteOnSiteHint")}
        value={
          <>
            {formatVolume(onSiteVolume)} m<sup>3</sup>
          </>
        }
      />
    </div>
  );
};
